import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
export var CALL_SERVICE = 'inst-redux-service-middleware-CALL_SERVICE';
export function createServiceMiddleware(origServices) {
  var services = Object.assign(Object.create(null), origServices);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type !== CALL_SERVICE) return next(action);
        var _action$payload = action.payload,
          serviceKey = _action$payload.service,
          method = _action$payload.method,
          args = _action$payload.args;
        var service = services[serviceKey];
        if (!service) throw new Error("service ".concat(serviceKey, " undefined"));
        if (!service[method]) throw new Error("service method ".concat(method, " undefined"));
        var realArgs = args ? args.slice() : [];
        realArgs.push(store);
        var response = service[method].apply(service, _toConsumableArray(realArgs));
        // Pass on this event after the service has done what the service wants w/ current state
        next(action);
        // Then return the service
        return response;
      };
    };
  };
}
export default createServiceMiddleware;